import React from "react";
import { useTranslation } from "react-i18next";
import { WorkflowBadgeLg } from "@dreamhub/designsystem/icons";
import FormNew from "@/components/controls/Form/FormNew";
import { FormSectionProps } from "@/components/controls/Form/FormSection";
import { FormFieldNewType } from "@/components/controls/Form/types";
import { WorkflowDetailsFormData, WorkflowSelectOption } from "./types";

interface WorkflowDetailsFormProps {
  defaultWorkflowType: string;
  workflowTypeOptions: WorkflowSelectOption[];
  stageOptions: WorkflowSelectOption[];
  stageId?: string;
  onFormValidation: (valid: boolean, data: WorkflowDetailsFormData) => void;
  onSubmit: (data: WorkflowDetailsFormData) => void;
}

const WorkflowDetailsForm: React.FC<WorkflowDetailsFormProps> = ({
  defaultWorkflowType,
  workflowTypeOptions,
  stageOptions,
  stageId,
  onFormValidation,
  onSubmit
}) => {
  const { t } = useTranslation();

  const formFields: FormFieldNewType[] = [
    {
      name: "workflowType",
      label: t("workflows.form.workflowType"),
      type: "singleSelect",
      required: true,
      labelPosition: "left",
      fieldActionProps: {
        options: workflowTypeOptions,
        fieldName: "workflowType"
      },
      defaultValue: defaultWorkflowType
    },
    {
      name: "workflowName",
      label: t("workflows.form.workflowName"),
      type: "text",
      required: true,
      labelPosition: "left",
      fieldActionProps: {
        placeholder: t("workflows.form.workflowNamePlaceholder")
      }
    },
    {
      name: "workflowDescription",
      label: t("workflows.form.workflowDescription"),
      type: "textarea",
      required: false,
      labelPosition: "left",
      fieldActionProps: {
        placeholder: t("workflows.form.workflowDescriptionPlaceholder")
      }
    },
    {
      name: "workflowStage",
      label: t("workflows.form.workflowStage"),
      type: "singleSelect",
      required: true,
      labelPosition: "left",
      fieldActionProps: {
        options: stageOptions,
        fieldName: "workflowStage"
      },
      defaultValue:
        stageId || (stageOptions.length > 0 ? stageOptions[0].id : "")
    }
  ];

  const formSections: FormSectionProps[] = [
    {
      id: "workflow-details",
      fields: formFields,
      fieldsContainerClassName: "gap-2"
    }
  ];

  return (
    <div className="p-6">
      <div
        className="flex flex-col gap-6 max-w-none mx-auto"
        style={{ width: "552px" }}
      >
        <div className="flex justify-center">
          <WorkflowBadgeLg />
        </div>
        <FormNew
          sections={formSections}
          isFormValid={(valid: boolean, watchAllFields: Record<string, unknown>) =>
            onFormValidation(
              valid,
              watchAllFields as unknown as WorkflowDetailsFormData
            )
          }
          onSubmit={(data: unknown) => onSubmit(data as WorkflowDetailsFormData)}
        />
      </div>
    </div>
  );
};

export default WorkflowDetailsForm;
